import clsx from 'clsx'
import type { IconType } from '../svg/icon'
import Icon from '../svg/icon'

type Props = {
	icon: IconType
	variant?:
		| 'solid-accent'
		| 'solid-white'
		| 'solid-white-shade'
		| 'faded-white'
		| 'outline-accent'
		| 'outline-white'
		| 'outline-soft-white'
	size?: 'sm' | 'lg'
	disabled?: boolean
	className?: string
	iconClassName?: string
	type?: 'button' | 'submit' | 'reset'
}

export default function IconButton({
	icon,
	variant = 'solid-accent',
	size = 'lg',
	disabled = false,
	className,
	iconClassName,
	type = 'button',
	...props
}: Props & JSX.IntrinsicAttributes & React.ButtonHTMLAttributes<HTMLButtonElement>) {
	return (
		<button
			className={clsx(
				'relative flex items-center justify-center  border transition-colors group shrink-0 disabled:opacity-20',
				variant,
				size === 'sm' ? 'h-8 w-8 rounded-md' : 'h-[60px] w-[60px] rounded-lg',
				className
			)}
			disabled={disabled}
			type={type}
			{...props}
		>
			<Icon icon={icon} className={clsx(size === 'sm' ? 'w-4 h-4' : 'w-6 h-6', iconClassName)} />
		</button>
	)
}
